import React from "react";

export type StatItem = {
  value: string;
  label: string;
  highlight?: boolean;
};

type Props = {
  items: StatItem[];
};

const ElectionStats = ({ items }: Props) => {
  return (
    <div className="v26-stats-grid">
      {items.map((item, i) =>
        item.value || item.label ? (
          <div className={"v26-stat" + (item.highlight ? " highlight" : "")} key={i}>
            <div className="val">{item.value}</div>
            <div className="label">{item.label}</div>
          </div>
        ) : (
          <div key={i} />
        )
      )}
    </div>
  );
};

export default ElectionStats;
